import type {FindingRating, RiskRating, EvaluationScore} from "../../types";

export const riskRatingConfig: Record<RiskRating, {label: string; bg: string; color: string}> = {
  low: {label: "Low", bg: "green.100", color: "green.800"},
  medium: {label: "Medium", bg: "yellow.100", color: "yellow.800"},
  significant: {label: "Significant", bg: "red.200", color: "red.800"},
};

export const findingRatingConfig: Record<FindingRating, {label: string; bg: string; color: string}> = {
  low: {label: "Low", bg: "blue.100", color: "blue.800"},
  moderate: {label: "Moderate", bg: "yellow.100", color: "yellow.800"},
  high: {label: "High", bg: "red.200", color: "red.800"},
};

export const evaluationScoreConfig: Record<NonNullable<EvaluationScore>, {label: string; bg: string; color: string}> = {
  1: {label: "Ineffective", bg: "red.200", color: "red.800"},
  2: {label: "Partially Effective", bg: "yellow.100", color: "yellow.800"},
  3: {label: "Effective", bg: "green.100", color: "green.800"},
};

export const evaluationArcColor: Record<NonNullable<EvaluationScore>, string> = {
  1: "var(--chakra-colors-red-500)",
  2: "var(--chakra-colors-yellow-500)",
  3: "var(--chakra-colors-green-500)",
};
